import { ActionButtonProps, Box, BoxProps, ColorOptions, Form, Loader, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useCallback, useEffect, useRef, useState } from 'react'
import { ListNew } from '../../components/ListNew'
import { SearchFilter } from '../../components/SearchFilter'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { NbForm } from './NbForm'
import { formData } from './formData'

const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}
const NetbankingMapping = () => {
  const [enableDetails, setDetails] = useState(false)
  const [isExpanded, setisExpanded] = useState<{ isExpanded: boolean; value: number }>({ isExpanded: false, value: -1 })
  const { getNbByEntityId, nbData, addNB, getEntityNameMap, entityMap, accessConfig } = useStores((store) => ({
    getNbByEntityId: store.netBanking.getByEntityId,
    nbData: store.netBanking.getNetbankingData(),
    length: store.netBanking.banks.length,
    addNB: store.netBanking.addNB,
    getEntityNameMap: store.entityMaster.getEntityNameMap,
    entityMap: store.entityMaster.getEntityMap(),
    accessConfig: store.user.getAccessConfig(['entity_config', 'net_bank_mapping']),
  }))

  const resetFormRef = useRef<any>(null)
  const [nbMap, setNbMap] = useState({})
  const [search, setSearch] = useState('')

  const [getByEntityId, getNbByEntityIdHandler] = useLazyApiData(getNbByEntityId)
  const [lazyAddNetBank, lazyAddNetBankHandler] = useLazyApiData(addNB)

  const [lazyEntityIdNameMap] = useLazyApiData(getEntityNameMap)

  const onSearch = (data: any) => {
    setSearch(data?.search)
    getByEntityId(data?.search, { page: 1, size: 10 })
  }

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const headTitles = [
    { id: 'ID' },
    { entityID: 'Entity ID' },
    { bankName: 'Bank Name' },
    { entityCode: 'Entity Code' },
    { rpslCode: 'RPSL Code' },
    { status: 'Status' },
  ]

  const onNbPress = ({ item }: any, index: number) => {
    console.log({ item })
    setNbMap(item)
    isAccessible(accessConfig, 'update') &&
      setisExpanded({ isExpanded: !isExpanded.isExpanded, value: isExpanded.value === item?.id ? -1 : item?.id })
  }

  const fetchDataFromServer = useCallback(
    (_, paginationInfo) => getByEntityId(search, paginationInfo),
    [getByEntityId, search],
  )

  const getNetbankingList = () => {
    if (!enableDetails) {
      return null
    }

    const getExpandView = () => {
      return (
        <NbForm
          nbMapping={nbMap}
          onUpdate={onUpdate}
          isDeletable={isAccessible(accessConfig, 'delete')}
          onClose={() => setisExpanded({ isExpanded: false, value: isExpanded.value })}
        />
      )
    }

    return (
      <Box marginTop={16}>
        {search && (
          <ListNew
            keyExtractor={keyExtractor}
            headTitle={headTitles}
            sizeConfig={[1, 2, 2, 2, 2, 1]}
            data={getNbByEntityIdHandler?.data?.content}
            onRowItemClick={onNbPress}
            listTitle={'Netbanking Mapping List'}
            showExpandArrow={true}
            expandView={getExpandView}
            isExpanded={isExpanded.isExpanded}
            expandedIndex={isExpanded.value}
            fetchDataFromServer={fetchDataFromServer}
            apiHandler={getNbByEntityIdHandler}
            updatedPaginationInfo={{
              ...(getNbByEntityIdHandler?.data?.pageNo !== undefined && { page: getNbByEntityIdHandler?.data?.pageNo }),
              ...(getNbByEntityIdHandler?.data?.totalElements !== undefined && {
                total: getNbByEntityIdHandler?.data?.totalElements,
              }),
            }}
            dbCollumnMapper={{
              entityID: 'entityId',
            }}
          />
        )}
      </Box>
    )
  }

  useEffect(() => {
    if (getNbByEntityIdHandler.state === 'fulfilled') {
      setDetails(true)
    }
  }, [getNbByEntityIdHandler])

  useEffect(() => {
    if (lazyAddNetBankHandler.state === 'fulfilled') {
      console.log('add netbank')
      resetFormRef?.current({})
    }
  }, [lazyAddNetBankHandler])

  useEffect(() => {
    lazyEntityIdNameMap()
  }, [lazyEntityIdNameMap])

  const handleActions = ({ values, title, defaultActionButtonOnSubmit, resetForm }: ActionButtonProps) => {
    resetFormRef.current = resetForm
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }
    return (
      <Box paddingTop={8} align={'center'} justify={'center'}>
        <ButtonNew
          title={title}
          onPress={handleOnPress}
          isLoading={lazyAddNetBankHandler.state === 'pending'}
          width={280}
          color={'#214796' as ColorOptions}
          titleColor={'WHITE'}
          textType={'bodyMedium14'}
          paddingHorizontal={36}
        />
      </Box>
    )
  }

  const addNetbank = (data: any) => {
    lazyAddNetBank(data)
  }

  const onUpdate = () => {
    getByEntityId(search, { page: 0, size: 10 })
    setisExpanded({ isExpanded: false, value: -1 })
  }

  return (
    <Box>
      {isAccessible(accessConfig, 'fetch') && <SearchFilter onSearch={onSearch} placeholder={'Search By Entity Id'} />}
      {getNbByEntityIdHandler.state === 'pending' && <Loader />}
      {getNetbankingList()}
      <Spacer direction={'vertical'} size={24} />
      {isAccessible(accessConfig, 'add') && (
        <>
          <Box {...styles.topContainer} bg={'#f8f9fc' as ColorOptions}>
            <Text fontFamily="jiotype-bold" color={'#214796' as ColorOptions} fontSize={16} title={'Add New Mapping'} />
          </Box>
          <Box {...styles.formContainer}>
            <Form
              initialValues={{
                bankName: '',
                entityCode: '',
                entityId: '',
                rpslCode: '',
                status: '',
              }}
              formData={formData(addNetbank, entityMap)}
              actionButtons={handleActions}
              container={FormBox}
            />
          </Box>
        </>
      )}
    </Box>
  )
}

export default NetbankingMapping

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.22,
  shadowRadius: 2.22,
  elevation: 3,
}

const styles = {
  topContainer: {
    ...shadow,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  formContainer: {
    ...shadow,
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
    borderColor: '#e3e6f0' as ColorOptions,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  } as BoxProps,
}
